const tabOption = {
	userSetting: [
		{
			name: '用户管理',
			value: 'userView',
			power: ['setting-user'],
		},
		{
			name: '角色管理',
			value: 'roleView',
			power: ['setting-role'],
		},
		{
			name: '服务人员',
			value: 'serviceView',
			power: ['setting-service'],
		},
	],
	serviceView: [
		{
			name: '企微客服',
			value: 'customer',
			power: ['platform-customer'],
		},
		{
			name: '常见问题',
			value: 'cquestions',
			power: ['platform-cquestions'],
		},
		{
			name: '排班管理',
			value: 'schedule',
			power: ['platform-schedule'],
		},
	],
	surveyView: [
		{
			name: '全部问卷',
			value: 'survey',
			power: ['platform-survey'],
		},
		{
			name: '机构问卷',
			value: 'madSurvey',
			power: ['platform-madsurvey'],
		},
		{
			name: '门诊问卷',
			value: 'menSurvey',
			power: ['platform-mensurvey'],
		},
	],
	pagetableView: [
		// {
		//   name: '患者列表',
		//   value: 'patientlist',
		//   power: []
		// },
		{
			name: '患者项目',
			value: 'patienttab',
			power: [],
		},
		{
			name: '身体成分',
			value: 'composition',
			power: [],
		},
		{
			name: '围度',
			value: 'circumference',
			power: [],
		},
		{
			name: '血压',
			value: 'blood',
			power: [],
		},
		{
			name: '肝硬度',
			value: 'fibroscan',
			power: [],
		},
		{
			name: '眼科',
			value: 'eyes',
			power: [],
		},
		{
			name: '体重',
			value: 'weight',
			power: [],
		},
		{
			name: '饮食打卡',
			value: 'food',
			power: [],
		},
		{
			name: '运动记录',
			value: 'sport',
			power: [],
		},
		{
			name: '用药记录',
			value: 'medication',
			power: [],
		},
		{
			name: '问卷',
			value: 'questionnaire',
			power: [],
		},
		{
			name: '随访问卷',
			value: 'question_doc',
			power: [],
		},
		{
			name: '呼吸睡眠监测',
			value: 'breath',
			power: [],
		},
		{
			name: 'QCT',
			value: 'qct',
			power: [],
		},
		{
			name: '血糖',
			value: 'bloodSugar',
			power: [],
		},
		{
			name: '皮肤',
			value: 'skin',
			power: [],
		},
		{
			name: '不良感受',
			value: 'adverseReaction',
			power: [],
		},
		{
			name: '握力',
			value: 'gripStrength',
			power: [],
		},
		{
			name: 'MRI-PDFF结果',
			value: 'mriPDFF',
			power: [],
		},
	],
	postMessage: [
		{
			name: '群发消息',
			value: 'massView',
			power: [],
		},
		{
			name: '图片',
			value: 'sucaiView-img_view',
			power: [],
		},
		{
			name: '视频',
			value: 'sucaiView-video_view',
			power: [],
		},
		{
			name: '文件',
			value: 'sucaiView-file_view',
			power: [],
		},
		{
			name: '小程序',
			value: 'sucaiView-mini_view',
			power: [],
		},
	],
	// medicalSetting: [
	//   {
	//     name: '医疗机构',
	//     value: 'medicalView',
	//     power: ['setting-medical']
	//   },
	//   {
	//     name: '登记处',
	//     value: 'applyView',
	//     power: ['setting-apply']
	//   },
	// ],
};
export default tabOption
